module.exports = __webpack_public_path__ + "static/media/gcp.c75ff0f7.png";